/*-----------------------------------------------------------------------------
  Loopr dual price (eks. mva / ink. mva)
  Replaces the T-Selector app embed.

  - Shopify prices are stored EX VAT (bedrift). Ink. mva = pris * 1.25.
  - Tags every .money element with data-b2b (original text) and data-b2c
    (computed), which initPriceToggle() in custom.js already switches between.
  - Re-runs on DOM changes so JS-rendered prices (cart drawer, quick shop,
    variant changes, filtered grids) are covered too.
-----------------------------------------------------------------------------*/
(function () {
  var VAT_RATE = 1.25;
  var SELECTOR = '.money';
  var scheduled = null;

  /*
    custom.js has an older looprApplyCartTotal() that rewrote <cart-total>
    in nb-NO format and multiplied by 1.25 for Privat. Combined with this
    script that would double-convert. This script loads right after custom.js,
    so we replace it with a no-op and own the cart total here.
  */
  if (typeof window.looprApplyCartTotal !== 'undefined') {
    window.looprApplyCartTotal = function () {};
  }

  function currentMode() {
    return localStorage.getItem('loopr-pricing') || 'b2b';
  }

  /* Parse "25,000 NOK", "1.234,50 kr", "kr 5 721" etc. */
  function parsePrice(text) {
    var m = text.match(/(\d(?:[\d.,\u00a0\s]*\d)?)/);
    if (!m) return null;
    var raw = m[1];
    var prefix = text.slice(0, m.index);
    var suffix = text.slice(m.index + raw.length);

    var decimals = 0;
    var decimalSep = '';
    var thousandsSep = '';

    var dec = raw.match(/([.,])(\d{1,2})$/);
    var intPart = raw;
    var fracPart = '';
    if (dec) {
      decimalSep = dec[1];
      fracPart = dec[2];
      decimals = fracPart.length;
      intPart = raw.slice(0, raw.length - dec[0].length);
    }

    var sepMatch = intPart.match(/[.,\u00a0\s]/);
    if (sepMatch) thousandsSep = sepMatch[0];

    var digits = intPart.replace(/[^\d]/g, '');
    if (!digits) return null;
    var value = parseFloat(digits + (fracPart ? '.' + fracPart : ''));
    if (isNaN(value)) return null;

    if (!thousandsSep) {
      var fmt = (window.theme && window.theme.money_format) || '';
      if (fmt.indexOf('comma_separator') !== -1) {
        thousandsSep = '.';
        if (!decimalSep) decimalSep = ',';
      } else if (fmt.indexOf('space_separator') !== -1) {
        thousandsSep = ' ';
        if (!decimalSep) decimalSep = ',';
      } else {
        thousandsSep = ',';
        if (!decimalSep) decimalSep = '.';
      }
    }

    return {
      value: value,
      rebuild: function (newValue) {
        var fixed = decimals > 0 ? newValue.toFixed(decimals) : String(Math.round(newValue));
        var parts = fixed.split('.');
        var intStr = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
        var out = intStr;
        if (decimals > 0) out += decimalSep + parts[1];
        return prefix + out + suffix;
      }
    };
  }

  function tagElement(el) {
    var text = (el.textContent || '').trim();
    if (!text) return;

    if (el.dataset.b2b && (text === el.dataset.b2b || text === el.dataset.b2c)) return;

    if (el.querySelector && el.querySelector(SELECTOR)) return;

    var parsed = parsePrice(text);
    if (!parsed) return;

    el.dataset.b2b = text;
    el.dataset.b2c = parsed.rebuild(parsed.value * VAT_RATE);

    if (currentMode() === 'b2c') {
      el.textContent = el.dataset.b2c;
    }
    el.dataset.pricing = currentMode();
  }

  function tagAll() {
    document.querySelectorAll(SELECTOR).forEach(tagElement);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      tagAll();
    });
  }

  function init() {
    tagAll();

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes.length) { schedule(); return; }
        if (m.type === 'characterData') {
          var p = m.target.parentElement;
          if (p && p.closest && p.closest(SELECTOR)) {
            var el = p.closest(SELECTOR);
            var t = (el.textContent || '').trim();
            if (t !== el.dataset.b2b && t !== el.dataset.b2c) { schedule(); return; }
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    ['cart:updated', 'cart:refresh', 'variant:change', 'shopify:section:load'].forEach(function (evt) {
      document.addEventListener(evt, schedule);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.looprDualPriceRefresh = tagAll;
})();
